"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledModalDialog = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ModalDialogMixin = require("../../mixins/components/ModalDialogMixin");
var _Modal = require("../Modal/Modal");
var StyledModalDialog = /*#__PURE__*/(0, _styledComponents.default)(_Modal.Modal).withConfig({
  displayName: "StyledModalDialog",
  componentId: "c11n-8-107-0__sc-13vcfw8-0"
})(["", ""], _ModalDialogMixin.ModalDialogMixin);
exports.StyledModalDialog = StyledModalDialog;